/**
 * Instagram validation error codes shared between the backend (which throws them) and the
 * frontend (which maps them to user-facing messages).
 */
export const IG_ERROR_CODE = {
  /** Profile does not exist / handle is malformed. */
  INVALID: "EINVALIDIGPROFILE",
  /** Profile exists but is private. */
  PRIVATE: "EPRIVATEIGPROFILE",
  /** Profile exists but is age restricted. */
  AGE_RESTRICTED: "EAGERESTRICTEDIGPROFILE",
  /** Profile exists but has fewer than the minimum required followers. */
  LOW_FOLLOWERS: "EFOLLOWERCOUNT",
  /** Profile exists but has fewer than the minimum required posts. */
  LOW_POSTS: "EPOSTCOUNT",
  /** Handle already exists in our system. */
  EXISTING_PROFILE: "EEXISTINGIGPROFILE",
} as const;

export type IgErrorCode = (typeof IG_ERROR_CODE)[keyof typeof IG_ERROR_CODE];

/**
 * Valid Instagram handle: 3-30 chars of a-z, 0-9, "." and "_"; no leading,
 * trailing, or consecutive dots. Shared so the backend, the dashboard's
 * selection groups, and any other consumer agree on what a valid handle is.
 */
export const VALID_IG_HANDLE_REGEX = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{2,29}$/;
